export const emptyData = () => ({
  candidate: {
    profile_for: "", full_name: "", dob: "", time_of_birth: "", place_of_birth: "", mother_tongue: "",
    height: "", weight: "", complexion: "", religion: "", nationality: "Indian", marital_status: "",
    gana: "", rashi: "", manglik: "NA", caste: "", sub_caste: "", blood_group: "", food_habits: "",
    physically_challenged: "NA", highest_qualification: "", medium_of_education: "", occupation: "",
    job_details: "", place_of_work: "", annual_income: "", about: "",
  },
  family: {
    father_name: "", mother_name: "", father_occupation: "", mother_occupation: "",
    family_type: "", siblings: "", married_siblings: "",
  },
  private: {
    applicant_name: "", applicant_mobile: "", applicant_full_address: "", relationship_with_candidate: "",
    present_address: "", present_pin: "", present_whatsapp: "", present_phone: "", present_email: "",
    same_as_present: false,
    permanent_address: "", permanent_pin: "", permanent_whatsapp: "", permanent_phone: "", permanent_email: "",
    nearest_relative_residence: "",
  },
  preferences: {
    age_min: "", age_max: "", height_min: "", height_max: "", education: "", location: "", community: "", notes: "",
  },
  uploads: { profile_photo: null, gallery: [], id_proof: null },
  meta: { manglik_yes: false, pc_yes: false },
  agreement: { consent: false },
});

export function mergeDraft(draft) {
  const base = emptyData();
  Object.keys(base).forEach((k) => {
    base[k] = { ...base[k], ...((draft && draft[k]) || {}) };
  });
  return base;
}

const pick = (shape, rec) => Object.fromEntries(Object.keys(shape).map((k) => [k, rec?.[k] ?? shape[k]]));

export function fromRecords({ profile, family, priv, prefs }) {
  const d = emptyData();
  d.candidate = pick(d.candidate, profile);
  d.family = pick(d.family, family);
  d.private = pick(d.private, priv);
  d.preferences = Object.fromEntries(Object.entries(pick(d.preferences, prefs)).map(([k, v]) => [k, v === null ? "" : String(v)]));
  d.meta = {
    manglik_yes: !!profile.manglik && profile.manglik !== "NA",
    pc_yes: !!profile.physically_challenged && profile.physically_challenged !== "NA",
  };
  return d;
}

export function calcAge(dob) {
  if (!dob) return null;
  const d = new Date(`${dob}T00:00:00`);
  if (Number.isNaN(d.getTime())) return null;
  const now = new Date();
  let age = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) age -= 1;
  return age;
}

const clean = (obj) =>
  Object.fromEntries(Object.entries(obj).map(([k, v]) => [k, typeof v === "string" ? v.trim() || null : v]));

const PERM_KEYS = ["address", "pin", "whatsapp", "phone", "email"];

export function buildPayload(data) {
  const candidate = clean({
    ...data.candidate,
    manglik: data.meta.manglik_yes ? data.candidate.manglik : "NA",
    physically_challenged: data.meta.pc_yes ? data.candidate.physically_challenged : "NA",
  });
  const priv = { ...data.private };
  if (priv.same_as_present) PERM_KEYS.forEach((k) => { priv[`permanent_${k}`] = priv[`present_${k}`]; });
  const prefs = clean(data.preferences);
  prefs.age_min = prefs.age_min ? Number(prefs.age_min) : null;
  prefs.age_max = prefs.age_max ? Number(prefs.age_max) : null;
  return {
    candidate,
    family: clean(data.family),
    private: clean(priv),
    preferences: prefs,
    uploads: data.uploads,
    consent: data.agreement.consent === true,
  };
}
